import { useMemo } from 'react';
import { createPortal } from 'react-dom';
var Portal = _ref => {
  var {
    children,
    container
  } = _ref;
  var existingRoot = typeof document !== 'undefined' ? document.getElementById('root') : null;
  var target = useMemo(() => {
    if (container instanceof HTMLElement) return container;
    return existingRoot || document.body;
  }, [container, existingRoot]);
  if (!target) return null;
  return createPortal(children, target);
};
export default Portal;